import { Pipe, PipeTransform } from '@angular/core';

const padraoLimitacao = /^(.+?)\s+(\S+)$/;
const removerTags = (str) => str.replace(/<\/?[^>]+(>|$)/g, '');
const isTextoMenorQueLimite = (str, limite) => (str.length <= limite);
const isLimitadoPalavraCompleta = (textoCheio, limite) => (textoCheio[limite] === ' ');
const adicionarReticencias = (texto) => texto.trim() + ' ...';
const removerUltimaPalavra = (str) => padraoLimitacao.exec(str)[1];
const limitarTexto = (str, limite) => str.substr(0, limite);

@Pipe({
  name: 'limitarTexto',
})
export class LimitarTextoPipe implements PipeTransform {

  transform(texto: string, limite: number): string {
    const textoTotal = removerTags(texto);
    let textoLimitado = '';

    if (isTextoMenorQueLimite(textoTotal, limite)) {
      return textoTotal;
    }

    textoLimitado = limitarTexto(textoTotal, limite);

    // se o caracter de limite for um espaço,
    if (isLimitadoPalavraCompleta(textoTotal, limite)) {
      return adicionarReticencias(textoLimitado);
    }

    // procura a ultima paladra e remove ela,
    // pelo fato de estar incompleta...
    if (padraoLimitacao.test(textoLimitado)) {
      return adicionarReticencias(removerUltimaPalavra(textoLimitado));
    }

    return adicionarReticencias(textoLimitado);
  }
}
